import Navigation from "../components/navigation";
import { useTheme } from "@mui/material/styles";
import Settings from "../components/settings";
import { useEffect } from "react";

export default function SettingsRoute() {
  const theme = useTheme();

  //Bug fix that makes the settings page scroll to the top when navigating to it
  //Before sometimes this was not the case
  useEffect(() => {
    document.body.scroll(0, 0);
  }, []);

  return (
    <div style={{ marginLeft: theme.spacing(2) }}>
      <Navigation />
      <Settings />
    </div>
  );
}
